module.exports = __webpack_public_path__ + "img/fv_top_pc.1729c5f8.png";